module.exports = __webpack_public_path__ + "img/wedcr5.ecc7db9a.jpg";